/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_SubheadlineInputs */

const en_landing_cta_subheadline = /** @type {(inputs: Landing_Cta_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop wiring auth, payments, and RBAC from scratch. Start with ShipAny Next and build what actually makes your product unique.`)
};

const zh_landing_cta_subheadline = /** @type {(inputs: Landing_Cta_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`别再从零搭建认证、支付和权限系统了。用 ShipAny Next 起步，专注打造真正让产品与众不同的东西。`)
};

/**
* | output |
* | --- |
* | "Stop wiring auth, payments, and RBAC from scratch. Start with ShipAny Next and build what actually makes your product unique." |
*
* @param {Landing_Cta_SubheadlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_cta_subheadline = /** @type {((inputs?: Landing_Cta_SubheadlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_SubheadlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cta_subheadline(inputs)
	return zh_landing_cta_subheadline(inputs)
});
export { landing_cta_subheadline as "landing.cta.subheadline" }